import React, { forwardRef, useState } from 'react';
import { IInputProps, Input } from './Input';
import { RightIcon } from './RightIcon';
import EyeIcon from '../../../../visuals/Icons/Eye';
import EyeStrokedIcon from '../../../../visuals/Icons/EyeStroked';
import { IconSizes } from '../../../../visuals/Icons/type';

export const InputPassword = forwardRef<
  HTMLInputElement,
  Omit<IInputProps, 'type' | 'children'>
>(({ ...props }, ref) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <Input type={isPasswordVisible ? 'text' : 'password'} {...props} ref={ref}>
      <RightIcon onClick={() => setIsPasswordVisible(!isPasswordVisible)}>
        {isPasswordVisible ? (
          <EyeStrokedIcon size={IconSizes.md} />
        ) : (
          <EyeIcon size={IconSizes.md} />
        )}
      </RightIcon>
    </Input>
  );
});
